module.exports = __webpack_public_path__ + "static/media/label_important_24px_outlined.448a129f.svg";